import styled from "@emotion/native";
import Button from "../../../../components/Button";

export const Container = styled.View({
	flex: 1,
	justifyContent: "space-between",
	paddingBottom: 50,
});

export const Snippets = styled.View({});

export const Snippet = styled.View({
	marginBottom: 40,
});

export const Cta = styled(Button)({});

export const ImgTop = styled.Image({
	flex: 1,
	width: "100%",
	height: 300,
	marginBottom: 30,
});

export const ImgBottom = styled.Image({
	flex: 1,
	width: "100%",
	height: 300,
	marginTop: 30,
});
